;(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const cookieBanner = document.querySelector('.cookies-consent')
    const acceptCookiesButton = document.querySelector('#cookies-accept')
    const rejectCookiesButton = document.querySelector('#cookies-reject')
    function gtag() {
      dataLayer.push(arguments)
    }

    let cookieLevelValue = document.cookie.split('; ').find(row => row.startsWith('cookie_consent_level='))

    if (cookieLevelValue !== undefined) {
      cookieLevelValue = cookieLevelValue.split('=')[1]
      if (cookieLevelValue === undefined) {
        cookieLevelValue = '0'
      }
    } else {
      cookieLevelValue = '0'
    }

    if (cookieLevelValue === '1') {
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted',
      })
    }

    // var gtagScript = document.createElement('script')
    // gtagScript.async = true
    // gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-609SVTCQ5V'

    // var firstScript = document.getElementsByTagName('script')[0]
    // firstScript.parentNode.insertBefore(gtagScript, firstScript)

    if (cookieBanner && acceptCookiesButton && rejectCookiesButton) {
      let cookieAcceptedValue = document.cookie.split('; ').find(row => row.startsWith('cookie_consent_user_accepted='))

      if (cookieAcceptedValue !== undefined) {
        cookieAcceptedValue = cookieAcceptedValue.split('=')[1]
        if (cookieAcceptedValue === undefined) {
          cookieAcceptedValue = 'false'
        }
      } else {
        cookieAcceptedValue = 'false'
      }

      if (cookieAcceptedValue !== 'true') {
        cookieBanner.classList.remove('hidden')
      }

      acceptCookiesButton.addEventListener('click', () => {
        document.cookie = 'cookie_consent_level=1; max-age=31536000; samesite=strict; path=/'
        document.cookie = 'cookie_consent_user_accepted=true; max-age=31536000; samesite=strict; path=/'
        cookieBanner.classList.add('hidden')
        gtag('consent', 'update', {
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          ad_storage: 'granted',
          analytics_storage: 'granted',
        })
      })

      rejectCookiesButton.addEventListener('click', () => {
        document.cookie = 'cookie_consent_level=0; max-age=31536000; samesite=strict; path=/'
        document.cookie = 'cookie_consent_user_accepted=true; max-age=31536000; samesite=strict; path=/'
        cookieBanner.classList.add('hidden')
      })
    }
  })
})()
